import { reactive } from 'vue';

export type ToastSeverity = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: number;
  severity: ToastSeverity;
  message: string;
}

// Plain reactive singleton (not Pinia) so it can be driven from the message util,
// which is also called outside component setup.
const state = reactive({ items: [] as Toast[] });
let seq = 0;

const TOAST_TTL = 3000; // auto-dismiss after 3s

export const toastState = state;

export function pushToast(severity: ToastSeverity, message: string): number {
  const id = ++seq;
  state.items.push({ id, severity, message });
  // Auto-dismiss; can also be closed early via the X (dismissToast is a no-op
  // if it's already gone).
  setTimeout(() => dismissToast(id), TOAST_TTL);
  return id;
}

export function dismissToast(id: number): void {
  const i = state.items.findIndex((t) => t.id === id);
  if (i >= 0) state.items.splice(i, 1);
}

export function clearToasts(): void {
  state.items.splice(0);
}
